// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import store from "./store"

export const selectAcceptsMarketing = store.select.customer.acceptsMarketing

export const selectCartQuantity = store.select.checkout.quantity

export const selectCartTotal = store.select.checkout.cartTotal

export const selectCheckoutLink = store.select.checkout.checkoutLink

export const selectCouponCodeApplied = store.select.checkout.couponCodeApplied

export const selectAutomaticDiscountApplied =
  store.select.checkout.automaticDiscountApplied

export const selectAutomaticDiscountAllocations =
  store.select.checkout.automaticDiscountAllocations
